import { ActionHeader } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions';
import { getActionHeadersForActions } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ServiceCatalog/ServiceCatalogService';
import { ActionsCallout } from 'components/actions/ActionsCallout';
import { useFolderStore } from 'domains/portal/FolderStore';
import React, { useRef, useState } from 'react';
import { removeCategories as removeActionCategories } from 'utils/ActionUtils';
import { WorkflowCatalogTree } from './WorkflowCatalogTree';
import { IWorkflowCatalogNode, ServiceCatalogTreeNodeType } from './WorkflowCatalogUtils';

interface IWorkflowCatalogProps {}

export const workflowCatalogTreeId = 'workflowCatalogTreeId';

/**
 * Render Workflow catalog directly from React
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function WorkflowCatalog(_props: IWorkflowCatalogProps) {
  const [menuActions, setMenuActions] = useState<ActionHeader[]>();
  const menuElementRef: React.MutableRefObject<HTMLElement | null> = useRef(null);

  const showContextMenu = async (node: IWorkflowCatalogNode, element: HTMLElement) => {
    menuElementRef.current = element;

    if (node.nodeType === ServiceCatalogTreeNodeType.ServiceCatalog) {
      let actions = await getActionHeadersForActions({ entityID: node.id, actionsName: ['Delete', 'Edit'] });
      actions = removeActionCategories(actions);
      setMenuActions(actions);
    } else {
      const folderViewData = await useFolderStore.getState().folderStoreActions.getFolderViewData();
      let actions = folderViewData?.ActionHeaders.filter(filterFolderActions) || [];
      actions = removeActionCategories(actions);
      setMenuActions(actions);
    }
  };

  const onMenuClose = () => {
    menuElementRef.current = null;
    setMenuActions(undefined);
  };

  return (
    <>
      <WorkflowCatalogTree treeId={workflowCatalogTreeId} showContextMenu={showContextMenu} />
      {menuActions && menuActions.length && (
        <ActionsCallout
          sourceRef={menuElementRef}
          preLoadedActions={menuActions}
          onClose={onMenuClose}
          placement="right"
        />
      )}
    </>
  );
}

function filterFolderActions(action: ActionHeader) {
  return action.Ca === 'Add Catalog Item' || action.Nm === 'Pin to Top Menu' || action.Nm === 'Move Folder to Root';
}
